//import destinations from '../data/destinations';
//import TravelDestination from '../components/TravelDestination';
import '../styles/travel.scss';
import WorldMap from '../components/WorldMap';
import usePageTitle from '../hooks/usePageTitle';

function Travel() {
  usePageTitle('World Map | Dochano')
  return (
    <section className="travel-container">
      <div id="Intro">
          <h1>World Map</h1>
      </div>
      <WorldMap />

      {/*destinations.map(destination => (
        <TravelDestination key={destination.id} destination={destination} />
      ))*/}
      
    </section>
  );
}

export default Travel;